import type { Issuance } from "./types.js";

/** Display-only states; do not change the production/API status contract. */
export const issuanceStatusLabels = {
  issued: "불출 완료",
  in_progress: "부분 회수",
  inspection_pending: "검수 대기",
  inspecting: "검수중",
  correcting: "수정중",
  completed: "완료",
  cancelled: "취소"
} as const;

export type IssuanceDisplayStatus = keyof typeof issuanceStatusLabels;

export function issuanceDisplayStatus(issuance: Issuance): IssuanceDisplayStatus {
  if (isFullyCancelledIssuance(issuance)) return "cancelled";
  if (isInspectionInProgress(issuance)) return "inspecting";
  if (issuance.correctionOfReturnId && issuance.correctionQuantity > 0) return "correcting";
  return issuance.status;
}

/** Partial recalls retain their completed/QC work; only wholly cancelled work is cancelled. */
export function isFullyCancelledIssuance(issuance: Pick<Issuance, "status" | "returnedQuantity" | "quantity" | "cancelledQuantity"> & Partial<Pick<Issuance, "reworkTransferredQuantity" | "reworkSourceIssuanceId" | "cancelledAt">>) {
  if (issuance.quantity === 0 && (issuance.reworkSourceIssuanceId || issuance.reworkTransferredQuantity) && !issuance.cancelledAt) return false;
  return issuance.status === "completed" && issuance.returnedQuantity === 0
    && (issuance.cancelledQuantity ?? 0) === issuance.quantity;
}

export function isReworkLinkedIssuance(issuance: Issuance) {
  return Boolean(issuance.reworkSourceIssuanceId || issuance.reworkTransferredQuantity || issuance.returns.some(row => row.correctionOfReturnId));
}

/** Keep production/return states stable; QC progress is an informational overlay. */
export function isInspectionInProgress(issuance: Pick<Issuance, "returns">) {
  const returns = issuance.returns ?? [];
  const continued = new Set(returns.map(record => record.correctionOfReturnId).filter(Boolean));
  return returns.some(record => record.inspectionStartedAt && !record.inspectionId && !continued.has(record.id));
}
